import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MeetingLocationsListComponent } from './meeting-locations-list/meeting-locations-list.component';
import { MeetingLocationService } from './meeting-locations-list/meeting-location.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes: Routes = [
  {
    path : '',
    component : MeetingLocationsListComponent,
    resolve : {
      data : MeetingLocationService
    }
  }
]

@NgModule({
  declarations: [MeetingLocationsListComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FuseSharedModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatTableModule,
  ]
})
export class MeetingLocationsModule { }
